<div class="server-error-container" role="alert" [attr.aria-label]="'SERVER_ERROR.TITLE' | translate">
  <div class="error-content">
    <div class="error-logo">
      <img src="assets/img/logo-a1102.svg" [alt]="'common.LOGO_ALT' | translate" class="logo-img" />
    </div>
    <main class="error-main">
      <div class="error-code" aria-hidden="true">
        <span class="code-number">5</span>
        <span class="code-circle">0</span>
        <span class="code-number">0</span>
      </div>

      <div class="error-message">
        <h1 class="error-title" tabindex="0">{{ 'SERVER_ERROR.TITLE' | translate }}</h1>

        <p class="error-description error" *ngIf="status === 'failed'" tabindex="0">
          ⚠️ {{ 'SERVER_ERROR.FAILED_MSG' | translate }}
        </p>
      </div>

      <div class="action-buttons">
        <button
          class="btn btn-secondary"
          [disabled]="cooldown > 0"
          (click)="goHome()"
          [attr.aria-label]="cooldown > 0 ? ('SERVER_ERROR.WAIT_MSG' | translate: { time: cooldown }) : ('SERVER_ERROR.GO_HOME' | translate)"
        >
          {{ 'SERVER_ERROR.GO_HOME' | translate }}
          <span *ngIf="cooldown > 0"> 
            ({{ 'SERVER_ERROR.WAIT_MSG' | translate: { time: cooldown } }}) 
          </span>
        </button>
      </div>
    </main>
  </div>
</div>